// extracted by mini-css-extract-plugin
export default {"footerRow":"Footer_footerRow__6HEl7","copyrights":"Footer_copyrights__0ecLT","workers":"Footer_workers__+b1x5"};